import React, {
    createContext, useState, useMemo, useCallback,
    useEffect,
} from 'react';
import { isHalloweenPages } from '../OrderDetails/OrderDetailsBoxes/components/BoxesCheckForm';


type DishDetailsContextProviderProps = {
    children: React.ReactNode,
}

// TODO: copy paste
type Slide = {
    type: 'video' | 'img',
    alt?: string,
    imageUrl?: string,
    imageUrlDesktop?: string,
    src?: string,
}

type OpenDetailsOptions = {
    slide?: Slide
};


export const DishDetailsContext = createContext({
    detailsIsOpen: false,
    initialDishId: '',
    handleOpenDetails: (dishId: string) => { }, // eslint-disable-line no-unused-vars
    handleCloseDetails: () => { },
});


export function DishDetailsContextProvider({ children }: DishDetailsContextProviderProps) {
    const [detailsIsOpen, setDetailsIsOpen] = useState(false);
    const [initialDishId, setInitialDishId] = useState('');
    const [activeDetailsSlide, setActiveDetailsSlide] = useState<Slide | null>(null);

    const handleOpenDetails = useCallback((dishId: string, options: OpenDetailsOptions = {}) => {
        setDetailsIsOpen(true);
        setInitialDishId(dishId);

        if (options.slide) {
            setActiveDetailsSlide(options.slide);
        }
    }, []);

    const handleCloseDetails = useCallback((timeout?: number) => {
        setDetailsIsOpen(false);
        setActiveDetailsSlide(null);

        if (timeout) {
            setTimeout(() => {
                setInitialDishId('');
            }, timeout);
        } else {
            setInitialDishId('');
        }
    }, []);

    const value = useMemo(() => {
        const v = {
            detailsIsOpen,
            initialDishId,
            activeDetailsSlide,
            handleOpenDetails,
            handleCloseDetails,
        };
        return v;
    }, [
        detailsIsOpen, initialDishId, activeDetailsSlide,
        handleOpenDetails, handleCloseDetails,
    ]);

    const openHalloweenDishDetail = useCallback(
        (e: any) => {
            const id = e.target?.id;
            if (!id) return;
            handleOpenDetails(id);
        },
        [handleOpenDetails],
    );

    const isHalloweenPage = isHalloweenPages();

    useEffect(
        () => {
            if (isHalloweenPage) return undefined;
            // !window.location.pathname.includes('halloween')

            const halloweenDishContainer = document.querySelector('.cards-list.halloween');
            halloweenDishContainer?.addEventListener('click', openHalloweenDishDetail);
            return () => {
                halloweenDishContainer?.removeEventListener('click', openHalloweenDishDetail);
            };
        },
        [openHalloweenDishDetail],
    );

    return (
        <DishDetailsContext.Provider value={value}>
            {children}
        </DishDetailsContext.Provider>
    );
}
